import axios from 'axios'
import APP_CONSTANT from '../../config/constants';
import { LOCAL_STORAGE } from '../utils/constants';

const AxiosRequest = async function (props = {}) {
    let token = LOCAL_STORAGE.userToken
    let userId = LOCAL_STORAGE.userId
    let customerNo = LOCAL_STORAGE.customerNo
    let congData =
    {
        customerNo: customerNo,
        customerNumber: customerNo,
        userId: userId,
        ...props.Items
    }

    let response = await axios.request({
        baseURL: props.baseURL ? props.baseURL : APP_CONSTANT.BASE_COMMON,
        url: props.method == 'get' ? `${props.url}${props.getValues ? `?${props.getValues}` : '?'}customerNo=${customerNo}&page=1&limit=10&customerNumber=${customerNo}&userId=${userId}${props.hStatus ? `&common_delivery=1&customer_no=${customerNo}&user_id=${userId}` : ''}` : props.url,
        method: props.method,
        data: props.method != 'get' ? congData : '',
        headers: {
            'Content-Type': ` ${props.contentType ? props.contentType : 'application/json'};charset=utf-8`,
            'Authorization': `${token}`
        },
    })
    let resp = new Promise((resolve, reject) => {
        if (response.status === 200) {
            resolve(response)
        } else {
            reject(response)
        }
    })
    return resp;
}

export default AxiosRequest